import React from "react";

import styled from "@mui/material/styles/styled";

import Stack from "@rui/Stack";

const Badge = styled(Stack)(({ theme }) => ({
  color: "white",
  fontSize: "0.625rem",
  right: -4,
  top: -4,
  backgroundColor: theme.palette.shades.blush[500],
  borderRadius: "4px",
  minWidth: "12px",
  width: "fit-content",
  height: "12px",
  padding: "2px",
}));

const NotificationBadge = ({
  notifications,
  absolutePositioning,
}: {
  notifications: number;
  absolutePositioning?: boolean;
}) => {
  const notificationsAmount = notifications > 99 ? "99+" : notifications;
  return (
    <Badge
      variant="center"
      sx={{
        position: absolutePositioning ? "absolute" : "unset",
        marginLeft: absolutePositioning ? "12px" : "0",
        marginBottom: absolutePositioning ? "16px" : "0",
        padding: "2px",
      }}
    >
      {notificationsAmount}
    </Badge>
  );
};

export default NotificationBadge;
